export function getPeriorityNum(priority) {
  return { high: 2 }[priority];
}
